// modalStyles.tsx
import styled, { createGlobalStyle } from "styled-components";
import Modal from "react-modal";
import {
  WHITE,
  PRIMARY_BLUE_02,
} from 'bd-web-components/src/utils/dash-colors';
import { getDashColor } from "../../styles";

export const CustomModal = styled(Modal)`
  position: fixed;
  top: 94px;

  background-color: #fff;;
  border: none;
  padding: 9px;
  width: 279px;
  height: 100%;
  max-width: 90%;
  outline: none;
  @media (max-width: 1000px) {
    top: 63px;
  }
  z-index: 2;
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 20px 0 20px;
  font-weight: 700;
  width: 100%;
  position: sticky;
  top: 70px;
`;

export const MenuItem = styled.div`
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  padding: 14px 15px;
  margin-bottom: 9px;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  font-size: 16px;
  font-style: normal;
  font-weight: 1100;
  line-height: 22.4px;
  color: ${PRIMARY_BLUE_02};

  &:hover {
    background-color: ${getDashColor('GRAY_SCALE_09', 'ACCENT_RED_COLOR')};
  }

  &.active {
    color: ${WHITE};
    background-color: ${getDashColor('SECONDARY_BLUE_05', 'SECONDARY_COLOR')};
    font-weight: 700;
  }

  &.sub {
    font-weight: 400;
    font-style: normal;
    font-size: 15px;
    line-height: 22.5px;
    background-color: transparent;
    margin-bottom: 4px;
    color: #8c8c8c;

    &:hover {
      color: ${getDashColor('SECONDARY_BLUE_01', 'GRAY_DARK')};
    }

    &.active {
      color: ${getDashColor('SECONDARY_BLUE_01', 'PRIMARY_COLOR')};
      font-weight: 600;
    }
`;

export const MenuText = styled.div`
  flex: 1;
  padding-left: 21px;
`;

export const Collapse = styled.div`
  overflow: hidden;
  transition: 0.4s ease max-height;

  &.active {
    transition: 200ms ease;
  }

  & > div {
    overflow: auto;
  }

`;

export const Logo = styled.img`
  width: 36px;
  height: 36px;
`;

export const GlobalStyle = createGlobalStyle`
  .ReactModal__Body--open {
    overflow: hidden !important;
  }
`
